import React, { useState } from "react";
import Dialog from "components/Dialog/Dialog";
import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { actions as RequiredActions, selectors as RequiredGearSelectors } from "store/modules/requiredGear";

const style = ({ spacing }) => ({
    container: {
        marginBottom: spacing(2)
    }
})

function AddGearDialog({ classes }) {

    const dispatch = useDispatch();
    const [englishGearName, setEnglishGearName] = useState("");
    const [frenchGearName, setFrenchGearName] = useState("");
    const [gearStatus, setGearStatus] = useState(true);
    const isAddGearDialog = useSelector(RequiredGearSelectors.getIsAddGearDialog);

    // const gearStatusValue = [
    //     {
    //         value: true,
    //         label: "Active"
    //     },
    //     {
    //         value: false,
    //         label: "Inactive"
    //     }
    // ]

    const hideAddGearDialog = () => {
        dispatch(RequiredActions.setIsaddGearDialog(false));
    }

    const handleChangeEnglishGear = (event) => {
        setEnglishGearName(event.target.value);
    }

    const handleChangeFrenchGear = (event) => {
        setFrenchGearName(event.target.value);
    }

    const AddGear = () => {
        const values = {
            gearName: englishGearName,
            frenchGearName: frenchGearName,
            isActive: gearStatus
        }
        dispatch(RequiredActions.createRequiredGear(values));
        setEnglishGearName("");
        setFrenchGearName("");
        setGearStatus(true);
    }

    // const onGearStatusChange = (event) => {
    //     setGearStatus(event.target.value)
    // }


    return (
        <Dialog
            open={isAddGearDialog}
            title="Add Gear"
            onClose={hideAddGearDialog}
            onCancel={hideAddGearDialog}
            onConfirm={AddGear}
            disabled={!englishGearName?.trim() || !frenchGearName?.trim()}
            alertType="form"
            confirmText="Add Gear"
            size="sm"
            modalType="scrollable"
        >
            <div className={classes.container}>
                <TextField
                    id="englishGearName"
                    margin="normal"
                    label="Gear Name In English"
                    value={englishGearName}
                    onChange={handleChangeEnglishGear}
                    required
                    fullWidth
                />
                <TextField
                    id="frenchGearName"
                    margin="normal"
                    label="Gear Name In French"
                    value={frenchGearName}
                    onChange={handleChangeFrenchGear}
                    required
                    fullWidth
                />
                {/* <TextField
                    select
                    label="Gear Status"
                    value={gearStatus}
                    onChange={onGearStatusChange}
                    margin="normal"
                    fullWidth
                    required
                >
                    {gearStatusValue.map(({ value, label }) => (
                        <MenuItem key={`gearStatus-${value}`} value={value}>
                            {label}
                        </MenuItem>
                    ))}
                </TextField> */}
            </div>
        </Dialog>
    )
}

export default (withStyles(style)(AddGearDialog))
